import { defineComponent } from 'vue';
import style from './index.module.scss';
import logo from '@/assets/images/marketing/transfer-page/logo.png';
import offlineTips from '@/assets/images/marketing/transfer-page/offline-tips.png';
import tips from '@/assets/images/marketing/transfer-page/tips.png';
import qrCode from '@/assets/images/marketing/transfer-page/qrcode.jpg';
import bottomText from '@/assets/images/marketing/transfer-page/bottom-text.png';

export default defineComponent({
  name: 'TransferPage',
  setup() {
    return () => (
      <div class={style.container}>
        <div class={style.main}>
          <img class={style.logo} src={logo} alt="logo" />
          <img class={style.offlineTips} src={offlineTips} alt="下线提醒" />
          <img class={style.tips} src={tips} alt="扫码提醒" />
          <div class={style.qrCode}>
            <img src={qrCode} alt="公众号二维码" />
          </div>
          <img class={style.bottomText} src={bottomText} alt="公司文本" />
        </div>
      </div>
    );
  },
});
